import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import heroImage from "../../../assets/img/hero/technology.png";

class About extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="bg-light bg-about" id="about">
          <div className="container py-6">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-9 col-lg-6 order-1 order-lg-0 aos-init aos-animate" data-aos="fade-right">
                <div className="">
                  {/* <img className="img-fluid rounded-lg" src={heroImage} width="400" alt="ImanLogistics feature" /> */}
                </div>
              </div>
              <div className="col-lg-6 order-0 order-lg-1 mb-5 mb-lg-0 aos-init aos-animate text-white" data-aos="fade-up">
                <div className="mb-5 pt-8">
                  <h1 className="about-title">making transportation fast and reliable</h1>
                  <p className="lead pt-1 pb-5">Iman Logistics is a leading transportation and logistics provider based in Sydney and Perth, Australia.</p>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <h5>Interstate Land Transport</h5>
                    <p className="mb-2 small">With over 2 trips between Sydney and Perth each day, we deliver your goods interstate with speed.</p>
                  </div>
                  <div className="col-md-6 mb-4">
                    <h5>Intercity Consignments</h5>
                    <p className="mb-2 small mb-0">Within the Sydney and Perth regions, we have fast, same day deliveries for your most time sensitive articles.</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <h5>Warehousing</h5>
                    <p className="mb-2 small mb-0">Need to store something big? Our short/long term storage facilities are available.</p>
                  </div>
                  <div className="col-md-6 mb-4">
                    <h5>Online Tracking</h5>
                    <p className="small mb-0">Track your consignments online using our integrated tracking system (Coming Soon).</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default About;
